const ROME = "Europe/Rome";
const dayKey = (d) => d.toLocaleDateString("it-IT", { timeZone: ROME });

export function updateLabel(iso) {
  const d = new Date(iso);
  const time = d.toLocaleTimeString("it-IT", { timeZone: ROME, hour: "2-digit", minute: "2-digit" });
  if (dayKey(d) === dayKey(new Date())) return `Aggiornamento delle ${time}`;
  const day = d.toLocaleDateString("it-IT", { timeZone: ROME, day: "numeric", month: "short" });
  return `Aggiornamento del ${day}, ${time}`;
}

export function StoryUpdates({ updates }) {
  if (!updates?.length) return null;
  return (
    <section data-testid="article-updates" className="mt-6 flex flex-col gap-3">
      {updates.map((u, i) => (
        <div
          key={u.at}
          data-testid={`article-update-${i}`}
          className="border-l-2 border-brand bg-brand/5 rounded-r-lg px-4 py-3"
        >
          <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-wider text-brand mb-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse" aria-hidden="true" />
            {updateLabel(u.at)}
          </div>
          <p className="text-base text-onSurface leading-relaxed">{u.text}</p>
        </div>
      ))}
    </section>
  );
}
